module.exports = __webpack_public_path__ + "static/media/5.9.07377370.png";